import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../../../service/seo.service';

@Component({
    selector: 'app-green-transizione-ecologica',
    templateUrl: './green-transizione-ecologica.component.html',
    standalone: false
})
export class GreenTransizioneEcologicaComponent implements OnInit {

    constructor(private router: Router, private seoService: SeoService) { }

    ngOnInit(): void {
        const h2Text = "Agevolazioni green per PMI: bandi su energie rinnovabili, efficienza energetica e circolarità. Incentivi PNRR Transizione 5.0 e programma LIFE";
        
        this.seoService.updateSeo({
            titleSeo: "Bandi Green & Transizione Ecologica – PMI | Innovation Plaza",
            metadescription: h2Text
        });
    }

    goTo(route: string){		 
        this.router.navigate([route])
    }

}